// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/hub/products/:product\",\"regex\":\"^/hub/products/([^/]+)$\",\"paramNames\":[\"product\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/calculator\"},{\"path\":\"/hub\"},{\"path\":\"/hub/dashboard\"},{\"path\":\"/hub/products\"},{\"path\":\"/hub/suppliers\"},{\"path\":\"/scout/ideas\"},{\"path\":\"/scout/niche-history\"},{\"path\":\"/scout/research\"},{\"path\":\"/scout/search\"},{\"path\":\"/settings\"},{\"path\":\"/settings/account\"},{\"path\":\"/settings/personalization\"},{\"path\":\"/settings/subscription\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/verify\"},{\"path\":\"/legal-information/privacy-policy\"},{\"path\":\"/legal-information/tos\"},{\"path\":\"/login\"},{\"path\":\"/onboarding\"},{\"path\":\"/sentry-example-page\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';
import { env } from '@/env/env';

Sentry.init({
  // window.__ENV is populated by the synchronous /env.js script in <head>,
  // which executes before this (deferred) bundle.
  dsn: env('NEXT_PUBLIC_SENTRY_DSN'),

  // One envless build serves every environment; distinguish them by tag.
  environment: env('NEXT_PUBLIC_SENTRY_ENVIRONMENT'),

  // WE-115: Session Replay is NOT in the initial integrations list — it
  // records user sessions (potential PII) and must not start before consent.
  // enableSentryReplay() below adds it once the consent banner grants.
  integrations: [],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

// WE-115: enableSentryReplay() lives in src/events/core/sentryReplay.ts, not
// here — so importing it (e.g. from the consent banner) doesn't drag in this
// file's Sentry.init() side effect.

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
